<template>
  <div class="m-portlet m-portlet--mobile">
    <div class="m-portlet__head">
      <div class="m-portlet__head-caption">
        <div class="m-portlet__head-title">
          <h3 class="m-portlet__head-text">
            {{ labels.manage_child_segmenatations | capitalize }}
          </h3>
        </div>
      </div>

      <div class="m-portlet__head-tools">
        <ul class="m-portlet__nav" v-if="fullProductManagementAccess">
          <template v-if="fullProductManagementAccess && !crudMode">
            <li class="m-portlet__nav-item">
              <button
                @click="startExportAction"
                type="button"
                class="btn btn-elevate btn-icon-sm btn-pill"
              >
                <i class="la la-download"></i>
                {{ labels.export | capitalize }}
              </button>
            </li>
            <li class="m-portlet__nav-item">
              <a
                @click.prevent="toggleCRUDMode('create')"
                href="#"
                class="
                  btn btn-primary
                  m-btn m-btn--pill m-btn--custom m-btn--icon
                "
              >
                <i class="la la-plus"></i>
                {{ labels.new_child_segmentation }}
              </a>
            </li>
          </template>

          <li
            class="m-portlet__nav-item"
            v-else-if="fullProductManagementAccess && crudMode"
          >
            <a
              @click.prevent="toggleCRUDMode(null)"
              href="#"
              class="
                btn btn-primary
                m-btn m-btn--pill m-btn--custom m-btn--icon
              "
            >
              <i class="fa fa-reply"></i>
              {{ labels.return }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="m-portlet__body">
      <!--begin: Datatable -->
      <div
        id="m_table_1_wrapper"
        v-show="!crudMode"
        class="dataTables_wrapper dt-bootstrap4"
        style="overflow-x: auto"
      >
        <div class="row">
          <div class="col-sm-12">
            <table
              class="
                table table-striped- table-bordered table-hover table-checkable
                dataTable
                dtr-inline
              "
              id="m_table_1_child_segmentations"
              role="grid"
              aria-describedby="m_table_1_info"
              style="min-width: 1400px !important"
            >
              <thead>
                <tr role="row" class="thead-light">
                  <th
                    v-for="field in fields"
                    :class="sortingClass(field.sortable)"
                    tabindex="0"
                    aria-controls="m_table_1"
                    rowspan="1"
                    colspan="1"
                    style="width: 66.5px"
                    aria-sort="ascending"
                    aria-label="Record ID: activate to sort column descending"
                  >
                    {{ labels[field.id] | capitalize }}
                  </th>
                  <th
                    class="sorting_disabled"
                    rowspan="1"
                    colspan="1"
                    style="width: 68.5px"
                    aria-label="Actions"
                  >
                    {{ labels.actions }}
                  </th>
                </tr>
                <tr class="filter">
                  <th :key="'filter_' + field.id" v-for="field in fields">
                    <select
                      name
                      :id="field.filterName"
                      :data-key="field.id"
                      class="segmentation-choices"
                      multiple
                      v-if="field.searchType === 'multiChoice'"
                    ></select>

                    <input
                      type="text"
                      class="form-control m-input"
                      v-model.lazy="filters[field.filterName]"
                      v-else-if="field.searchType === 'text'"
                    />
                  </th>
                  <th style="display: grid">
                    <button
                      style="background-color: #1b7e9a; color: #ffff"
                      class="btn m-btn btn-sm m-btn--icon"
                      @click="resetFilters"
                    >
                      <i class="flaticon-refresh"></i>
                      &nbsp; {{ labels.reset | capitalize }}
                    </button>
                    <button
                      style="background-color: #1b7e9a; color: #ffff"
                      class="btn m-btn btn-sm m-btn--icon"
                      @click="closeAllTables"
                    >
                      <i class="la la-compress"></i>
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <child-segmentation-row
                  v-for="(data, index) in filteredData"
                  :data="data"
                  :index="index + 1"
                  :fields="fields"
                  :key="'row_data_' + (index + 1)"
                  :ref="'row_data_' + (index + 1)"
                ></child-segmentation-row>
              </tbody>
            </table>
            <!--        <div id="m_table_1_processing" class="dataTables_processing card" style="display: none;">Processing...</div></div></div>-->
            <!--        <div class="row"><div class="col-sm-12 col-md-5"><div class="dataTables_info" id="m_table_1_info" role="status" aria-live="polite">Showing 1 to 10 of 40 entries</div></div>-->
            <!--            <div class="col-sm-12 col-md-7 dataTables_pager"><div class="dataTables_length" id="m_table_1_length"><label>Display <select name="m_table_1_length" aria-controls="m_table_1" class="custom-select custom-select-sm form-control form-control-sm"><option value="5">5</option><option value="10">10</option><option value="25">25</option><option value="50">50</option></select></label></div>-->
            <!--                <div class="dataTables_paginate paging_simple_numbers" id="m_table_1_paginate"><ul class="pagination"><li class="paginate_button page-item previous disabled" id="m_table_1_previous"><a href="#" aria-controls="m_table_1" data-dt-idx="0" tabindex="0" class="page-link"><i class="la la-angle-left"></i></a></li><li class="paginate_button page-item active"><a href="#" aria-controls="m_table_1" data-dt-idx="1" tabindex="0" class="page-link">1</a></li><li class="paginate_button page-item "><a href="#" aria-controls="m_table_1" data-dt-idx="2" tabindex="0" class="page-link">2</a></li><li class="paginate_button page-item "><a href="#" aria-controls="m_table_1" data-dt-idx="3" tabindex="0" class="page-link">3</a></li><li class="paginate_button page-item "><a href="#" aria-controls="m_table_1" data-dt-idx="4" tabindex="0" class="page-link">4</a></li><li class="paginate_button page-item next" id="m_table_1_next"><a href="#" aria-controls="m_table_1" data-dt-idx="5" tabindex="0" class="page-link"><i class="la la-angle-right"></i></a></li></ul></div>-->
          </div>
        </div>
      </div>
      <!--end: Datatable -->
      <child-segmentation-form v-if="crudMode"></child-segmentation-form>
    </div>
  </div>
</template>

<script>
import Choices from "choices.js";
import { mapState, mapGetters, mapActions } from "vuex";
import XLSX from "xlsx";
import Swal from "sweetalert2";

import algoliaProductsAction from "../../../assets/js/algoliaProductsMixin";
import generalMixins from "../../../assets/js/mixins";

import ChildSegmentationForm from "./ChildSegmentationForm";
import ChildSegmentationRow from "./ChildSegmentationRow";

const moment = require("moment");

const tableChoices = {};
const dataNames = {
  themes: "themeName",
  segmentationParents: "parentName",
  childSegmentations: "segmentationName",
};
const cols = [
  { width: 25 },
  { width: 25 },
  { width: 25 },
  { width: 150 },
  { width: 150 },
  { width: 150 },
  { width: 150 },
];

export default {
  name: "ChildSegManagement",
  mixins: [algoliaProductsAction, generalMixins],
  components: {
    ChildSegmentationRow,
    ChildSegmentationForm,
  },
  data() {
    return {
      fields: [
        {
          id: "themeName",
          sortable: true,
          searchType: "multiChoice",
          filterName: "themes",
        },
        {
          id: "product_leaders",
          sortable: false,
          searchType: "text",
          filterName: "productLeaders",
        },
        {
          id: "parentName",
          sortable: true,
          searchType: "multiChoice",
          filterName: "segmentationParents",
        },
        {
          id: "segmentationName",
          sortable: true,
          searchType: "multiChoice",
          filterName: "childSegmentations",
        },
        {
          id: "verbatim_consos",
          sortable: false,
          searchType: "text",
          filterName: "verbatims",
        },
        {
          id: "products",
          sortable: false,
          searchType: "text",
          filterName: "products",
        },
        {
          id: "roles",
          sortable: false,
          searchType: "text",
          filterName: "productRoles",
        },
        {
          id: "patentRoles",
          sortable: false,
          searchType: "text",
          filterName: "patentRoles",
        },
      ],
      filters: {
        themes: [],
        segmentationParents: [],
        childSegmentations: [],
        verbatims: "",
        products: "",
        productRoles: "",
        patentRoles: "",
        productLeaders: "",
      },
      themes: {
        original: new Set(),
        filtered: new Set(),
      },
      segmentationParents: {
        original: new Set(),
        filtered: new Set(),
      },
      childSegmentations: {
        original: new Set(),
        filtered: new Set(),
      },
      lastChangedFilter: "",
      children: [],
      callbackList: [],
      timeoutProductInfo: null,
    };
  },
  watch: {
    filteredData: {
      handler(value) {
        value.length !== this.tableData.length
          ? this.filterChoices()
          : this.resetChoices();
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      labels: (store) => store.labels,
      crudData: (store) => store.crudData.cruds,
      crudMode: (store) => store.crudData.crudMode,
    }),
    ...mapGetters([
      "getName",
      "getResourceValue",
      "fullProductManagementAccess",
    ]),
    tableData() {
      this.children = [];
      const my = this;
      let child = {};
      let index = 0;
      const productIds = [];
      this.crudData.segmentations.forEach((segmentation) => {
        if (segmentation.hasOwnProperty("segmentation_parent")) {
          index += 1;
          const themeName =
            my.getName(segmentation.theme_id, "theme_id", "themes") || "";
          const parentName =
            my.getName(
              segmentation.segmentation_parent,
              "segmentation_id",
              "segmentations"
            ) || "";
          const verbatims = my.getVerbatimsList(
            segmentation.segmentation_id,
            index
          );
          const productLeadersList = my.getProductLeaderList(
            segmentation.theme_id
          );

          child = {
            themeName: themeName.trim(),
            parentName: parentName.trim(),
            segmentationName: segmentation.name ? segmentation.name.trim() : "",
            segmentation_id: segmentation.segmentation_id,
            verbatims,
            products: [],
            productLeaders: [],
            productRoles: [],
            patentRoles: [],
            productLeadersExtract: [],
            productsExtract: [],
            hasProducts: segmentation.products.length,
            hasProductLeaders: productLeadersList.length,
            hasVerbatims: verbatims.length,
          };

          if (segmentation.products) {
            segmentation.products.forEach((productId) => {
              productIds.push(productId);
            });

            this.callbackList.push({
              productIds: segmentation.products,
              object: child,
              objectKey: "products",
            });
          }

          if (segmentation.theme_id) {
            productLeadersList.forEach((productId) => {
              productIds.push(productId);
            });
            this.callbackList.push({
              productIds: productLeadersList,
              object: child,
              objectKey: "productLeaders",
            });
          }
          this.children.push(child);

          my.themes.original.add(themeName.trim());
          my.segmentationParents.original.add(parentName.trim());
          my.childSegmentations.original.add(child.segmentationName.trim());
        }
      });

      if (this.timeoutProductInfo) {
        console.log("clearing timeout");
        clearTimeout(this.timeoutProductInfo);
      }
      this.timeoutProductInfo = setTimeout(function () {
        my.getAlgoliaProductV2(
          productIds.filter(my.distinct),
          my.setProductDataV2
        );
      }, 500);

      return this.orderBy(
        this.children,
        { key: "themeName" },
        { key: "parentName" },
        { key: "segmentationName" }
      );
    },
    filteredData() {
      const my = this;
      if (this.filtersActive.length) {
        this.resetFilterLists();

        return this.tableData.filter((data) => {
          let filterCheck = 0;
          let matchPoint = 1;
          my.filtersActive.forEach((myFilter) => {
            matchPoint =
              myFilter === this.lastChangedFilter
                ? matchPoint * my.filtersActive.length
                : 1;
            this.dataMatch(myFilter, this.filters[myFilter], data)
              ? (filterCheck += matchPoint)
              : null;
          });

          if (filterCheck >= my.filtersActive.length) {
            let key;
            for (key in dataNames) {
              if (key !== this.lastChangedFilter) {
                this[key].filtered.add(data[dataNames[key]]);
              }
            }
            return true;
          }
          return false;
        });
      }
      return this.tableData;
    },
    filtersActive() {
      return Object.keys(this.filters).filter(
        (myFilter) => this.filters[myFilter].length
      );
    },
    excelHeaders() {
      const headerLabels = [];
      this.fields.forEach((field) => {
        headerLabels.push(
          this.$root.$options.filters.capitalize(this.labels[field.id])
        );
      });
      return headerLabels;
    },
  },
  methods: {
    ...mapActions(["toggleCRUDMode"]),
    sortingClass(sortable) {
      return "sorting_disabled";
    },
    distinct(value, index, self) {
      return self.indexOf(value) === index;
    },
    initChoices() {
      const my = this;
      $(".segmentation-choices").each(function () {
        const element = this;
        const elementId = $(this).attr("id");
        const dataKey = $(this).attr("data-key");

        tableChoices[elementId] = new Choices(element, {
          searchChoices: true,
          removeItems: true,
          removeItemButton: true,
          itemSelectText: "",
          duplicateItemsAllowed: false,
          searchFields: ["label"],
          searchFloor: 2,
          fuseOptions: {
            includeScore: 1,
            minMatchCharLength: 3,
            threshold: 0.3,
          },
          callbackOnInit() {
            this.setChoices(
              my.createChoices(my[elementId].original, elementId, dataKey),
              "value",
              "label",
              false
            );

            this.passedElement.element.addEventListener("addItem", (event) => {
              my.lastChangedFilter = elementId;
              my.filters[elementId].indexOf(event.detail.value) === -1
                ? my.filters[elementId].push(event.detail.value)
                : null;
              my.filteredData;
            });
            this.passedElement.element.addEventListener(
              "removeItem",
              (event) => {
                my.lastChangedFilter = elementId;

                const filterIndex = my.filters[elementId].indexOf(
                  event.detail.value
                );
                filterIndex !== -1
                  ? my.filters[elementId].splice(filterIndex, 1)
                  : null;
                my.filteredData;
              }
            );
          },
        });
      });
    },
    resetFilterLists() {
      let key;
      for (key in dataNames) {
        this[key].filtered = new Set();
      }
    },
    filterChoices() {
      let key;
      for (key in dataNames) {
        // 1st if key is first in the search order - we do NOT update the choices list
        if (key !== this.lastChangedFilter) {
          tableChoices[key].setChoices(
            this.createChoices(this[key].filtered, key),
            "value",
            "label",
            true
          );
        }
      }
    },
    createChoices(dataList) {
      const choices = new Set();

      dataList.forEach((data) => {
        const dataTrimmed = data.trim();
        choices.add({
          label: dataTrimmed,
          value: dataTrimmed,
          selected: false,
        });
      });
      return Array.from(choices);
    },
    dataMatch(filterName, value, data) {
      switch (filterName) {
        case "products":
          return this.productMatch(data, this.transformedSearchValue(value))
            .length;
        case "productLeaders":
          return this.productLeaderMatch(
            data,
            this.transformedSearchValue(value)
          ).length;
        case "verbatims":
          return this.verbatimMatch(data, this.transformedSearchValue(value))
            .length;
        case "productRoles":
          return this.productRoleMatch(data, this.transformedSearchValue(value))
            .length;
        case "patentRoles":
          return this.patentRoleMatch(data, this.transformedSearchValue(value))
            .length;
        default:
          return value
            ? this.arrayValueMatch(value, data[dataNames[filterName]])
            : false;
      }
    },
    arrayValueMatch(values, compareValue) {
      const results = values.filter((value) => value === compareValue).length;
      return results;
    },
    productLeaderMatch(data, value) {
      if (data.productLeaders) {
        const keyword = value.toLowerCase();

        return data.productLeaders.filter((product) => {
          const name = product.name
            ? this.transformedSearchValue(product.name.toLowerCase())
            : "";
          const brandName = product.brandName
            ? this.transformedSearchValue(product.brandName.toLowerCase())
            : "";
          const collectionName = product.collectionName
            ? this.transformedSearchValue(product.collectionName.toLowerCase())
            : "";
          return (
            name.indexOf(keyword) !== -1 ||
            brandName.indexOf(keyword) !== -1 ||
            collectionName.indexOf(keyword) !== -1
          );
        });
      }
      return false;
    },
    productMatch(data, value) {
      if (data.products) {
        const keyword = value.toLowerCase();

        return data.products.filter((product) => {
          const name = product.name
            ? this.transformedSearchValue(product.name.toLowerCase())
            : "";
          const brandName = product.brandName
            ? this.transformedSearchValue(product.brandName.toLowerCase())
            : "";
          const collectionName = product.collectionName
            ? this.transformedSearchValue(product.collectionName.toLowerCase())
            : "";
          return (
            name.indexOf(keyword) !== -1 ||
            brandName.indexOf(keyword) !== -1 ||
            collectionName.indexOf(keyword) !== -1
          );
        });
      }
      return false;
    },
    verbatimMatch(data, value) {
      if (data.verbatims) {
        return data.verbatims.filter((verbatim) =>
          verbatim
            ? this.transformedSearchValue(verbatim).indexOf(
                this.transformedSearchValue(value)
              ) !== -1
            : false
        );
      }
      return false;
    },
    productRoleMatch(data, value) {
      if (data.products) {
        return data.products.filter(
          (product) =>
            product.roles.filter(
              (role) =>
                this.transformedSearchValue(role).indexOf(
                  this.transformedSearchValue(value)
                ) !== -1
            ).length
        );
      }
      return false;
    },
    patentRoleMatch(data, value) {
      if (data.products) {
        return data.products.filter(
          (product) =>
            product.patentRoles.filter(
              (role) =>
                this.transformedSearchValue(role).indexOf(
                  this.transformedSearchValue(value)
                ) !== -1
            ).length
        );
      }
      return false;
    },
    filterByProductId() {},
    async setProductDataV2(results) {
      const my = this;
      this.callbackList.forEach((callbackItem) => {
        const productIdsData = results.filter(
          (result) =>
            result && callbackItem.productIds.indexOf(result.productId) !== -1
        );
        my.$set(callbackItem.object, callbackItem.objectKey, productIdsData);
        // Set product data with only product label i.e brand, collection, name
        my.$set(
          callbackItem.object,
          `${callbackItem.objectKey}Extract`,
          my.buildExtractData(productIdsData)
        );
        if (callbackItem.objectKey === "products" && productIdsData.length) {
          my.$set(
            callbackItem.object,
            "productRoles",
            my.buildExtractData(productIdsData, "productRoles")
          );
          my.$set(
            callbackItem.object,
            "patentRoles", // change here
            my.buildExtractData(productIdsData, "patentRoles")
          );
        }
      });
    },
    buildExtractData(results, type) {
      try {
        const data = [];
        const roleData = [];
        results.forEach((result) => {
          if (type && type === "productRoles" && result.roles) {
            result.roles.forEach((role) => {
              if (roleData.indexOf(role) === -1) {
                roleData.push(role);
              }
            });
          } else if (type && type === "patentRoles" && result.patentsV2) {
            result.patentsV2.forEach((patent) => {
              if (patent.roles) {
                patent.roles.forEach((role) => {
                  if (roleData.indexOf(role.name) === -1) {
                    roleData.push(role.name);
                  }
                });
              }
            });
          } else {
            data.push(
              `${result.brandName}, ${result.collectionName}, ${result.name}`
            );
          }
        });
        return type ? roleData.join("; ") : data.join("; ");
      } catch (err) {
        console.log(err);
        return null;
      }
    },
    resetFilters() {
      this.lastChangedFilter = "";
      let key;
      for (key in this.filters) {
        if (Array.isArray(this.filters[key])) {
          this.filters[key] = [];
        } else {
          this.filters[key] = "";
        }
        this.$forceUpdate();
      }
    },
    resetChoices() {
      let key;
      for (key in tableChoices) {
        if (tableChoices.hasOwnProperty(key) && tableChoices[key]) {
          tableChoices[key].destroy();
          tableChoices[key].init();
        }
      }
    },
    transformedSearchValue(keyword) {
      return keyword
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    closeAllTables() {
      let key;
      for (key in this.$refs) {
        if (key.indexOf("row_data_") !== -1) {
          this.$refs[key][0].closeAllChildren();
        }
      }
    },
    async createXLSSheet() {
      /* convert state to workbook */
      const ws = XLSX.utils.aoa_to_sheet(await this.createXLSData());

      /* Set worksheet sheet to "wide" */
      ws["!margins"] = {
        left: 1.0,
        right: 1.0,
        top: 1.0,
        bottom: 1.0,
        header: 0.5,
        footer: 0.5,
      };
      ws["!cols"] = cols;

      let i;
      for (i in ws) {
        /* all keys that do not begin with "!" correspond to cell addresses */
        if (i.indexOf("!") === -1) {
          ws[i].s = {
            alignment: {
              wrapText: 1, // any truthy value here
            },
          };
        }
      }
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export_segmentation_enfant_${moment().format("L")}.xlsx`
      );
    },
    async createXLSData() {
      const my = this;
      try {
        const data = [this.excelHeaders];
        await this.tableData.forEach((seg) => {
          async function getData() {
            const row = [];
            my.fields.forEach(async (field) => {
              const dataValue = seg[field.filterName] || seg[field.id];
              if (Array.isArray(dataValue)) {
                if (seg.hasOwnProperty(`${field.filterName}Extract`)) {
                  row.push(seg[`${field.filterName}Extract`]);
                } else {
                  row.push(dataValue.join("; "));
                }
              } else {
                row.push(dataValue);
              }
            });
            return data.push(await row);
          }
          getData();
        });
        return await data;
      } catch (err) {
        console.log(err);
      }
    },
    triggerRequestInProgress() {
      Swal({
        title: this.labels.export_in_progress,
        showConfirmButton: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen() {
          Swal.showLoading();
        },
      });
    },
    startExportAction() {
      this.triggerRequestInProgress();
      this.createXLSSheet();
      setTimeout(() => {
        Swal.close();
      }, 500);
    },
    getVerbatimsList(segId, index) {
      const namesList = this.crudData.verbatim_consos
        .filter((verbatim) => verbatim.segmentations.indexOf(segId) !== -1)
        .map((result) => result.name);
      return namesList;
    },
    getProductLeaderList(themeId) {
      const items = this.getResourceValue(
        themeId,
        "theme_id",
        "themes",
        "product_leaders"
      );

      return items !== "" ? items : [];
    },
  },
  mounted() {
    this.initChoices();
  },
};
</script>

<style>
.container {
  border: 2px solid #ccc;
  width: 300px;
  height: 100px;
  overflow-y: scroll;
}
#m_table_1_child_segmentations
  .choices__list--dropdown
  .choices__item--selectable {
  padding-right: 0px !important;
  font-size: 13px;
}
#m_table_1_child_segmentations .choices__input {
  font-size: 13px;
}
#m_table_1_child_segmentations .choices__list--multiple .choices__item {
  background-color: #1b7e9a;
  border: 1px solid #00c5dc;
}
#m_table_1_child_segmentations .choices__list.choices__list--dropdown {
  position: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CRUDs/Segmentations/ChildSegmentationTable.vue